<section fxLayout="column" ngClass.lt-sm="small">
  <div class="title-container" fxLayout="row">
    <h2 fxFlex="1 1 auto" class="left-title">News!</h2>
    <h2 fxHide.lt-md class="center-title">Aktuelle Projekte</h2>
    <h2 fxHide.lt-md fxFlex="1 1 auto" class="center-clone">News!</h2>
  </div>
  <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="100px">
    <div class="news-item" fxFlex="1 1 auto" fxLayout="column" fxLayoutAlign="center start" ngClass.lt-sm="small">
      <app-gallery-scroller [ladenObjects]="[newsObjectGewerbe]" [newsObject]="true" [newsObjectId]="-2"
                            newsObjectName="gewerbeimmobilien"
                            newsObjectBranche="Vermarktungshilfe"
                            [smallImages]="true" [blueArrows]="true"></app-gallery-scroller>
      <h3>Vermarktungshilfen für Gewerbeimmobilien</h3>
      <p>Für die schnelle und damit kostengünstige Vermarktung von Gewerbeimmobilien sind professionelle und
        aussagekräftige Unterlagen erforderlich – speziell wenn ein späteres Exposé Käufer oder Mieter überregional
        ansprechen soll.<br/>Welche Zielgruppe soll die Immobilie ansprechen? Lage, Fläche, Medien oder
        Ausstattungsniveau können erste Anhaltspunkte sein.<br/>Wir unterstützen Vermieter und Verkäufer durch die
        Erstellung von Fotos, Videos, Aufmaßen, Grundrissen und 3D-Animationen / Visualisierungen als Shop- bzw
        Homestaging. Dabei entstehen digital leere oder eingerichtete Büroräume, Praxisräume, Shops oder
        Restaurants.<br/>ABC Complett kann mehr – wir stellen Kontakte zu ausführenden Firmen her, oder realisieren die
        gewünschten Gewerke als Generalauftragnehmer.<br/><br/>Mit diesen Dienstleistungen, speziell bei
        Bestandsimmobilien, sind wir besonders Eigentümern, Verwaltern und Immobilienmaklern behilflich – der Service
        steht jedoch auch Architekten, Baufirmen und Wohnungsbaugesellschaften offen.</p>
    </div>
    <div class="news-item" fxFlex="1 1 auto" fxLayout="column" fxLayoutAlign="center start" ngClass.lt-sm="small">
      <div class="videoplayer">
        <video *ngIf="cookiesAgreed" poster="../../../assets/videos/Ladenbau-Berlin-Fruteria-Zeitraffer-Poster.jpg"
               [preload]="false" [controls]="true">
          <source src="../../../assets/videos/Ladenbau-Berlin-Fruteria-Zeitraffer.mp4" type="video/mp4">
          <source src="../../../assets/videos/Ladenbau-Berlin-Fruteria-Zeitraffer.webm" type="video/webm">
        </video>
        <div *ngIf="!cookiesAgreed" class="no-video" fxLayout="row" fxLayoutAlign="center center">
          <img defaultImage="../../../assets/images/ui/image-placeholder.png"
               lazyLoad="../../../assets/videos/Ladenbau-Berlin-Fruteria-Zeitraffer-Poster.jpg">
          <!--button mat-icon-button class="no-video-button" color="accent" (click)="playbuttonClicked()">
            <mat-icon>play_circle_filled</mat-icon>
          </button-->
        </div>
      </div>
      <h3>Umbau über Nacht</h3>
      <p>Das Kröpeliner Tor Center (KTC) in Rostock - Innerhalb von nur einer Nacht haben wir gemeinsam mit unseren
        Partnerfirmen die alte "Fruteria" demontiert und durch einen vollständig neuen Shop ersetzt. <br/>Auf Grund der
        zentralen Lage des Shops in der Mall wurden alle Arbeiten extrem gebündelt und außerhalb der
        Centeröffnungszeiten realisiert. <br/>Zeitgemäß in Design und Funktion, die neue "Fruteria".
        Das Refit wurde gestaltet von Concepts Media. <br/>Im Hinblick auf den Ladenbau - unter Berücksichtigung von
        Detailplanung, Abstimmung mit dem Center, Bauablaufplanung, Fertigung, Lieferung und Montage - vertraute unser
        Kunde auf ABC Complett.</p>
    </div>
    <div class="news-item" fxFlex="1 1 auto" fxLayout="column" fxLayoutAlign="center start" ngClass.lt-sm="small">
      <app-gallery-scroller [ladenObjects]="[newsObjectRoyalDonuts]" [newsObject]="true" [newsObjectId]="-1"
                            newsObjectName="royal donuts"
                            newsObjectBranche="Gastronomie"
                            [smallImages]="true" [blueArrows]="true"></app-gallery-scroller>
      <h3>Ausbau mehrerer Filialen von "Royal Donuts"</h3>
      <p>Zur Veranschaulichung haben wir hier verschiedene Phasen der Planerstellung bis hin zur 3-D-Visualisierung mit
        Bildern hinterlegt. <br/>
        Auf Basis vorhandener Grundrisse oder unseres Aufmaßes vor Ort, planen wir die Raumaufteilung und Funktionalität
        der Mietfläche, unter Berücksichtigung der gängigen gesetzlichen Vorgaben. Daran schließt sich die Erarbeitung
        eines Designkonzeptes an – mit Hilfe unserer 3-D-Animation können Materialien, Farben, Sichtachsen und
        Produktpräsentation veranschaulicht werden. Unsere Renderings lassen Dich den Spirit Deines neuen Shops hautnah
        erleben. <br/>Unsere Einrichtungspläne und Grundrisse sind später die Grundlage für die ausführenden Gewerke,
        genauso wie für Beantragungen und Abstimmungen mit dem Vermieter oder Center. <br/>Abc Complett
        Ladeneinrichtungs GmbH – Dein Ansprechpartner für Ladenbau in Berlin und Brandenburg.</p>
    </div>
  </div>
</section>
